const [w] = [window];

const domReady = () => {
  getArticleToModal( $('.free-banner__wrap'), {content: 'service',post_id: 3});
};

const getArticleToModal = ( $modalBody, param ) => {
  const applyDom = article => $modalBody.html( article.body );
  fetch(`/assets/api/getArticles/?${ new URLSearchParams(param)}`)
    .then( res => res.json()).then( res => applyDom(...res) );
}

export default function PUPPY () {
  w.addEventListener('load', function(){ 
    setTimeout(domReady,1000);
  }
);
}